__turbopack_context__.v({
  "counter-wrapper": "index-module-scss-module__4Ev7LW__counter-wrapper",
  "counter-wrapper__number": "index-module-scss-module__4Ev7LW__counter-wrapper__number",
});
